<div class="custom-pagination">
  <div *ngIf="pageSizes && pageSizes.length" class="pagination-size kt-margin-r-10">
    <select class="pagination-size-select" [(ngModel)]="pageSize" (change)="pageSizeChanged()">
      <option *ngFor="let size of pageSizes" [value]="size">{{size}}</option>
    </select>&nbsp;&nbsp;items per page
  </div>

  <span class="ag-paging-row-summary-panel kt-margin-r-10 kt-margin-l-10">
    <span class="ag-paging-row-summary-panel-number kt-padding-r-5">{{ (pageSize * (currentPage - 1)) + 1 }}</span>to
    <span class="ag-paging-row-summary-panel-number kt-padding-r-5">{{ currentPageMaxCount }}</span>of
    <span class="ag-paging-row-summary-panel-number">{{ totalRowsCount }}</span>
  </span>

  <div class="ag-paging-page-summary-panel">
    <div class="ag-paging-button-wrapper">
        <button type="button" class="ag-paging-button" (click)="goToFirstPage()"><span class="ag-icon ag-icon-first"></span><span class="paging-button-label">First</span></button>
    </div>
    <div class="ag-paging-button-wrapper">
        <button type="button" class="ag-paging-button" (click)="goToPreviousPage()"><span class="ag-icon ag-icon-previous"></span><span class="paging-button-label">Previous</span></button>
    </div>
    <span class="ag-paging-description">
        Page
        <span class="ag-paging-number">{{currentPage}}</span>
        of
        <span class="ag-paging-number">{{totalPages}}</span>
    </span>
    <span class="ag-paging-number"></span>
    <div class="ag-paging-button-wrapper">
        <button type="button" class="ag-paging-button" (click)="goToNextPage()"><span class="ag-icon ag-icon-next"></span><span class="paging-button-label">Next</span></button>
    </div>
    <div class="ag-paging-button-wrapper">
        <button type="button" class="ag-paging-button" (click)="goToLastPage()"><span class="ag-icon ag-icon-last"></span><span class="paging-button-label">Last</span></button>
    </div>
  </div>

</div>
